import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import classNames from 'classnames';

const AmexWithConfidence = ({ showmarketPlaceViewAmex }) => {
  return (
    <AmexWithConfidenceContent isMarketPlaceView={showmarketPlaceViewAmex} />
  );
};

const AmexWithConfidenceContent = ({ isMarketPlaceView = false }) => {
  const conatinerClasses = classNames(
    'flex-column gap-4 grayShadow16 width100',
    {
      pad8: !isMarketPlaceView,
    },
  );

  const headerClasses = classNames(
    'bgBlueB400 flex-shrink-0 formatMaxContent',
    {
      width100: isMarketPlaceView,
      padLR6: !isMarketPlaceView,
      padTB4: !isMarketPlaceView,
    },
  );

  const titleClasses = classNames(
    'fontWhite lineHeightNormal text-10 fontLatoNormal900',
    {
      width100: isMarketPlaceView,
      pad10: isMarketPlaceView,
    },
  );

  const bodyClasses = classNames('text-12 fontLato lineHeightNormal', {
    pad10: isMarketPlaceView,
    'm-text-10': !isMarketPlaceView,
    'flex-shrink-0': !isMarketPlaceView,
  });

  return (
    <FlexContainer className={conatinerClasses}>
      <FlexContainer className={headerClasses}>
        <Label className={titleClasses}>APPLY WITH CONFIDENCE</Label>
      </FlexContainer>
      <FlexContainer>
        <Label className={bodyClasses}>
          Know if you're approved with no credit score impact. If you're
          {isMarketPlaceView ? ' ' : <br />}approved and accept this Card, your
          credit score may be impacted.
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AmexWithConfidence;
